import { Navigate } from "react-router-dom";

import Loader from "@/components/Loader";
import { useCapabilityLanding } from "@/hooks/useCapabilityLanding";

function PostLoginRedirect() {
  const { loading, destination } = useCapabilityLanding();
  // Landing somewhere the user is about to be bounced off would flash an
  // error, so wait for the capabilities that decide where they belong.
  if (loading) return <Loader />;
  return <Navigate to={destination} replace />;
}

export default PostLoginRedirect;
